import { track } from '@eventbrite/datalayer-library';
import { gettext } from '@eventbrite/i18n';
import React, { useEffect } from 'react';
import { LISTING_HEAP_IDS } from '../../../constants';
import { useGetSegmentedCarouselExperiment } from '../../../experimentation';
import { SEGMENTED_CAROUSEL_EXPERIMENT_VALUES } from '../../../experimentation/constants';
import { RelatedEventsSection } from '../RelatedEventsSection';
import { OtherEventsYouMayLikeContentProps } from '../types';
import { OtherEventsYouMayLikeContent } from './OtherEventsYouMayLikeContent';
import { OtherEventsYouMayLikeSegmentedCarousel } from './OtherEventsYouMayLikeSegmentedCarousel';

export type OtherEventsYouMayLikeProps = OtherEventsYouMayLikeContentProps;

const CAROUSEL_HEADING = gettext('Other events you may like');

export function OtherEventsYouMayLike({
    eventId,
    eventCategory,
    shareComponentProps,
    isAuthenticated,
    areMetricsEnabled,
    eventsToRemove,
    locale,
    placeId,
}: OtherEventsYouMayLikeProps) {
    const segmentedCarouselExperimentVariant =
        useGetSegmentedCarouselExperiment();
    const isSegmentedCarouselExperiment =
        segmentedCarouselExperimentVariant !==
        SEGMENTED_CAROUSEL_EXPERIMENT_VALUES.CONTROL;

    useEffect(() => {
        //see for multiticket
        track({
            eventName: LISTING_HEAP_IDS.RECCOMENDATIONS_VIEW,
            eventData: {
                eventBucketLabel: 'Other Events you may like',
            },
        });
    }, []);

    return (
        <RelatedEventsSection
            className="listings-root__related-events"
            title={gettext('Other events you may like')}
            isSegmentedCarouselExperiment={isSegmentedCarouselExperiment}
        >
            {isSegmentedCarouselExperiment ? (
                <OtherEventsYouMayLikeSegmentedCarousel
                    {...{
                        eventId,
                        eventCategory,
                        shareComponentProps,
                        isAuthenticated,
                        areMetricsEnabled,
                        eventsToRemove,
                        locale,
                        placeId,
                        showToggleChips:
                            segmentedCarouselExperimentVariant ===
                            SEGMENTED_CAROUSEL_EXPERIMENT_VALUES.SEGMENTED_PILLS,
                    }}
                />
            ) : (
                <OtherEventsYouMayLikeContent
                    eventId={eventId}
                    isAuthenticated={isAuthenticated}
                    shareComponentProps={shareComponentProps}
                    areMetricsEnabled={areMetricsEnabled}
                    eventsToRemove={eventsToRemove}
                    locale={locale}
                    bucketLabel={CAROUSEL_HEADING.toString()}
                />
            )}
        </RelatedEventsSection>
    );
}
